var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuPulloverJunior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: .75px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34.1857282,
    y: 14.283943,
    width: 2.0880623,
    height: 19.1113199
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.2328855,
    cy: 16.566345,
    r: 0.4224887
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.2328855,
    cy: 29.0181139,
    r: 0.4224892
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.2328855,
    cy: 24.8675249,
    r: 0.4224892
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.2328855,
    cy: 20.716934,
    r: 0.4224892
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.5774251,17.8139856c2.9439774,0,4.3593979-.3456163,4.3593979-.3456163"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.8820974,17.8139856c-2.9439774,0-4.3594017-.3456163-4.3594017-.3456163"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.2737905,14.283943c1.7325439,0,3.7607765-.3569508,3.7607765-.3569508l.0081558-.0012169.875206,3.4575367c2.4228973,1.1104755,8.5715179,3.3324776,9.4390831,4.4620934,1.531311,1.9937706,3.9539146,10.5242901,4.7447891,14.2090759,1.2009315,5.5954475,4.034025,17.0036892,2.5810716,18.9019627l-4.5495644.8022156c-1.7960854-.8022156-2.2872293-4.9353413-2.9782121-7.8927006-1.2619209-5.4009705-3.134037-11.176075-3.9563103-14.3353157.7510567,6.5619812,1.4511528,18.4065628.3911781,21.3957748h-22.7517548c-1.0599403-2.989212-.3598785-14.8337936.3912106-21.3957748-.8222713,3.1592407-2.6944237,8.9343452-3.9563103,14.3353157-.6909828,2.9573593-1.6527465,6.7610739-3.4487985,7.5632895l-4.5495644-.8022156c-1.4529858-1.8982735,1.8507274-12.9771041,3.051657-18.5725516.7908421-3.6847858,3.213479-12.2153053,4.744792-14.2090759.8675632-1.1296158,7.0161819-3.3516178,9.4390812-4.4620934l.8911991-3.4602394.0234776.0039196s2.0282307.3569508,3.7607746.3569508"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.84614,
    y: 54.9278639,
    width: 22.7582397,
    height: 0.3028259
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "53.226139 56.0769274 57.7757072 55.2747233 57.6848067 54.9558947 53.1352424 55.7580988 53.226139 56.0769274"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "16.7299975 55.7456547 12.1804331 54.9434506 12.2713307 54.6246258 16.820896 55.4268261 16.7299975 55.7456547"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPulloverJunior);
export default __webpack_public_path__ + "static/media/Menu_Pullover_junior.e8b2bb054d2aae1ef9e7a0a3b212f75d.svg";
export { ForwardRef as ReactComponent };